import React, { useRef, useContext, useState, useEffect, useCallback, useMemo } from "react";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { Dropdown } from 'react-bootstrap';
import LogicContext from "../../Context/LogicContext";
import PermissionProfileDetailsScroll from "./PermissionProfileDetailsScroll";
import { permissionProfileService } from "../../services/permissionProfile.service";
import EditPermissionProfileModal from "./EditPermissionProfileModal";
import { createModal } from "react-modal-promise";
import GeneralModal from "../../helpers/GeneralModal";

const MenuAssignToProfileDetailsPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
    const myPromiseModal = createModal(GeneralModal);
  const logicContext = useContext(LogicContext);
  const [profileDetails, setProfileDetails] = useState({ profile_menu_info: [] });
  const [showEditModal, setShowEditModal] = useState(false); 
  const { pathname } = useLocation();
  const printRef = useRef(null);
  const url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];

  useEffect(() => {
    document.title = "Permission assign Details";
    loadDetailsData(id);
  }, [id]);

  const loadDetailsData = (id) => {
    permissionProfileService.profileDetails(id).then((response) => {
      const serverData = response.data;
      if (serverData) setProfileDetails(serverData);
      else setProfileDetails({ profile_menu_info: [] });
    }).catch((err) => {
      console.error(err);
      setProfileDetails({ profile_menu_info: [] });
    });
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: `Permission_Profile_${id}`,
  });

  const viewItemDetails = useCallback((adId) => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${adId}`);
  }, [currModuleId, currModuleName, navigate]);

  const groupedMenus = useMemo(() => {
    return profileDetails?.profile_menu_info?.reduce((acc, item) => {
      if (!acc[item.menu_parent_name]) acc[item.menu_parent_name] = [];
      acc[item.menu_parent_name].push(item);
      return acc;
    }, {}) || {};
  }, [profileDetails?.profile_menu_info]);

  const initialSelectedIds = useMemo(() => {
    return profileDetails?.profile_menu_info?.map((item) => item.menu_unique_id) || [];
  }, [profileDetails?.profile_menu_info]);



  const handleEditSave = useCallback(async (selectedMenuIds) => {
     const confirm = await myPromiseModal({
      title: ` ${selectedMenuIds.length  + "Menu(s) will be assigned to this profile"} `,
      body: `You are about to update ${selectedMenuIds.length} menu(s) to a new Profile`,
      showInput: false,
    });
    if (!confirm?.decision) return;


    const xmlItems = selectedMenuIds
      .map(menuId => `<a><menu_id>${menuId}</menu_id></a>`)
      .join('');

    const payload = new FormData();
    payload.set('option', 5);
    payload.set('menu_string', `<root>${xmlItems}</root>`);
    
     
      permissionProfileService.saveProfileAssign(id, payload).then((res) => {
            console.log('result ', res.data);
          loadDetailsData(id);
        setShowEditModal(false);
        })
        .catch((err) => {
          console.error("Failed to save menu permissions", err);
        });
     


    permissionProfileService.profileDetails(id).then((response) => {
        const serverData = response.data;
        if (serverData) setProfileDetails(serverData);
        else setProfileDetails({ profile_menu_info: [] });
      })
      .catch((err) => {
        console.error(err);
        setProfileDetails({ profile_menu_info: [] });
      })
      .finally(() => {
        setShowEditModal(false); 
      });
  }, [id]);

  return (
    <section className="mt-4 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      {/* ACTION BUTTONS */}
      <div className="flex justify-end gap-3 mb-6">
        {profileDetails?.action_status?.length > 0 && (
          <Dropdown>
            <Dropdown.Toggle className="text-sm text-white bg-blue-600 px-4 py-2 rounded-lg">ACTION</Dropdown.Toggle>
            <Dropdown.Menu>
              {profileDetails?.action_status?.map((option, i) => (
                <Dropdown.Item key={i}>{option?.status_name}</Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}

        <button
          onClick={() => setShowEditModal(true)}
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          <img src={pencil} alt="Edit" className="w-5 h-5" /> Edit Menu Access
        </button>



        {/* <button className="p-2 bg-red-500 text-white rounded-lg opacity-50 cursor-not-allowed">
          <img src={trash} alt="Delete" className="w-6 h-6" />
        </button> */}
      </div>

      <div className="flex flex-col lg:flex-row gap-8">
        {/* LEFT SIDE */}
        <PermissionProfileDetailsScroll viewItemDetails={viewItemDetails} />

        {/* RIGHT SIDE - Display */}
        <div ref={printRef} className="flex-1 bg-white shadow-xl rounded-xl p-6">
          <h1 className="text-2xl font-bold text-gray-800 mb-6">Permission Menu List</h1>

          {Object.keys(groupedMenus).length > 0 ? (
            Object.entries(groupedMenus).map(([parentName, menus]) => (
              <div key={parentName} className="mb-6 border rounded-lg overflow-hidden">
                <div className="bg-gray-100 px-4 py-2 font-semibold text-gray-700">
                  {parentName}
                </div>
                <div className="divide-y">
                  {menus.map((menu) => (
                    <div
                      key={menu.menu_unique_id}
                      className="px-4 py-3 flex justify-between hover:bg-gray-50"
                    >
                      <span className="font-medium text-gray-700">{menu.menu_name}</span>
                      <span className="text-xs text-gray-400">{menu.module_name}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-6 text-gray-500">No menu data found</div>
          )}
        </div>
      </div>

      <EditPermissionProfileModal
      id={id}
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        groupedMenus={groupedMenus}
        initialSelectedIds={initialSelectedIds}
        onSave={handleEditSave}
      />
    </section>
  );
};

export default MenuAssignToProfileDetailsPage;